module.exports = __webpack_public_path__ + "static/img/护理服务@3x.f20d010.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/dhry/assets/navs/护理服务@3x.png
// module id = 316
// module chunks = 379 380